@if (isDialog) {
  <div class="sidebar">
    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" class="dialog-close" mat-mini-fab aria-label="Close Sidebar"
        >
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }
    @if (initialized) {
      <div class="content">
        <form [formGroup]="inputForm">
          <div class="container">
            <section>
              @if (!project.id) {
                <h1>Add project</h1>
              }
              @if (project.id && editable) {
                <h1>Update project "{{project.name}}"</h1>
              }
              @if (project.id && !editable) {
                <h1>{{project.name}}</h1>
              }
            </section>
            <!-- Name -->
            <section>
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput type="text" autocomplete="off" formControlName="name" [errorStateMatcher]="matcher" />
                @if (inputForm.controls.name.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.name.hasError('error')) {
                  <mat-error>{{inputForm.controls.name.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            </section>
            <!-- /Name -->
            <!-- Number -->
            <section>
              <mat-form-field>
                <mat-label>Number</mat-label>
                <input matInput type="text" autocomplete="off" formControlName="number" [errorStateMatcher]="matcher" />
                @if (inputForm.controls.number.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.number.hasError('error')) {
                  <mat-error>{{inputForm.controls.number.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            </section>
            <!-- /Number -->
            <!-- Project duration -->
            <section>
              <mat-form-field>
                <mat-label>Select project duration</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate placeholder="Start date" formControlName="start_date" />
                  <input matEndDate placeholder="End date" formControlName="end_date" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker [calendarHeaderComponent]="calendarHeader"></mat-date-range-picker>
                @if (inputForm.controls.end_date.hasError('required') || inputForm.controls.start_date.hasError('required')) {
                  <mat-error
                    >
                    This field is <strong>required</strong>
                  </mat-error>
                }
              </mat-form-field>
            </section>
            <!-- /Project duration -->
            <!-- Project value -->
            <section>
              <mat-form-field>
                <mat-label>Project Value</mat-label>
                <input matInput type="number" autocomplete="off" formControlName="project_value"
                  [errorStateMatcher]="matcher" />
                @if (inputForm.controls.project_value.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.project_value.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.project_value.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            </section>
            <!-- /Project value -->
            <!-- Change Order Days -->
            <section>
              <mat-form-field>
                <mat-label>Change Order Days</mat-label>
                <input matInput type="number" min="0" autocomplete="off" formControlName="change_order_days"
                  [errorStateMatcher]="matcher" />
                <mat-hint>Additional days added to the project duration</mat-hint>
                @if (inputForm.controls.change_order_days.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.change_order_days.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            </section>
            <!-- /Change Order Days -->
            <!-- Status -->
            <section>
              <div class="mat-body-2">Status:</div>
              <mat-radio-group matInput aria-label="Select status" formControlName="status"
                [errorStateMatcher]="matcher">
                <mat-radio-button value="active">Open</mat-radio-button>
                <mat-radio-button value="inactive">Close</mat-radio-button>
                <!-- <mat-radio-button value="archived">Archived</mat-radio-button> -->
              </mat-radio-group>
              @if (inputForm.controls.status.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.status.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.status.errors.error}}
                </mat-error>
              }
            </section>
            <!-- /Status -->
            <!-- Description -->
            <section>
              <mat-form-field>
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" [errorStateMatcher]="matcher"></textarea>
                @if (inputForm.controls.description.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.description.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.description.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            </section>
            <!-- /Description -->
            <!-- new_labor_format section -->
            <section class="row">
              <div class="mat-body">New labor format</div>
              <div class="icons">
                <mat-slide-toggle formControlName="new_labor_format"></mat-slide-toggle>
                @if (inputForm.get('new_labor_format').hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.get('new_labor_format').hasError('error')) {
                  <mat-error>
                    {{inputForm.get('new_labor_format').errors.error}}
                  </mat-error>
                }
              </div>
            </section>
            <!-- /new_labor_format section -->
            <!-- offline_support section -->
            <section class="row">
              <div class="mat-body">Offline support</div>
              <div class="icons">
                <mat-slide-toggle formControlName="offline_support"></mat-slide-toggle>
                @if (inputForm.get('offline_support').hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.get('offline_support').hasError('error')) {
                  <mat-error>
                    {{inputForm.get('offline_support').errors.error}}
                  </mat-error>
                }
              </div>
            </section>
            <!-- /offline_support section -->
            <!-- location section -->
            <section>
              <div class="mat-body-2">Location:</div>
              @if (editable && (!project.latitude || !project.longitude)) {
                <div class="input-placeholder"
                  (click)="editLocation(project)">
                  <button mat-icon-button color="accent">
                    <mat-icon>location_on</mat-icon>
                  </button>Add Location
                </div>
              }
              @if (project.latitude) {
                <div (click)="editable && editLocation(project)">
                  <app-location-picker [isDialog]="false" [latitude]="project.latitude" [longitude]="project.longitude"
                  height="100px" [readOnly]="true"></app-location-picker>
                </div>
              }
            </section>
            <!-- /location section -->
            <!-- Cover photo -->
            <section>
              <div class="mat-body-2">Cover photo:</div>
              <div class="preview-list">
                @if (project.cover_photo?.id) {
                  <div>
                    <img [src]="project.cover_photo.getThumbnail()" />
                    @if (editable) {
                      <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon" (click)="removePicture()">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                }
                @if (editable && !project.cover_photo) {
                  <app-file-uploader class="input-placeholder small" icon="image"
                    accept="image/*" (complete)="onUploadComplete($event)">
                  </app-file-uploader>
                }
              </div>
            </section>
            <!-- /Cover photo -->
            <!-- Form Actions -->
            @if (editable) {
              <section>
                <div class="row">
                  <button mat-stroked-button color="primary" (click)="onSubmit()">
                    <ng-container>Save</ng-container>
                  </button>
                  <button mat-stroked-button (click)="onCancel()">Cancel</button>
                </div>
              </section>
            }
            <!-- Form Actions -->
          </div>
        </form>
      </div>
    }
  </div>
}
